<template>
  <b-card overlay :img-src="adPic" img-alt="主题图片" text-variant="white" :title="adTitle" sub-title="" sub-title-text-variant="white-50" img-height="400px">
    <!--b-button :href="$ADMIN_URL" target="admin_window" variant="primary" class="button-sytle">去登录看看</b-button-->
  </b-card>
</template>

<script>
export default {
  name: 'MainZone',
  data() {
    return {
      adPic: 'https://picsum.photos/900/250/?image=3',
      adTitle: '7000+家企业在线发布招聘岗位'
    }
  },
  created() {},
  mounted() {
    this.fetchData()
  },
  methods: {
    /**
     * 获取最后一条新的门户首页大Banner的图片
     */
    fetchData() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/get-portal-big-banner-last1',
          data: postData
        })
        .then((d) => {
          that.adPic = d.pic
          that.adTitle = ''
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取最后一条新的门户首页大Banner的图片失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.button-sytle {
  margin-top: 300px;
  margin-left: 20px;
}
</style>
